/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReferralInvitationStatusEnum,
    ReferralInvitationStatusEnumFromJSON,
    ReferralInvitationStatusEnumFromJSONTyped,
    ReferralInvitationStatusEnumToJSON,
} from './ReferralInvitationStatusEnum';

/**
 * 
 * @export
 * @interface ReferralInvitationDto
 */
export interface ReferralInvitationDto {
    /**
     * 
     * @type {string}
     * @memberof ReferralInvitationDto
     */
    email: string;
    /**
     * 
     * @type {Date}
     * @memberof ReferralInvitationDto
     */
    registeredAt: Date;
    /**
     * 
     * @type {ReferralInvitationStatusEnum}
     * @memberof ReferralInvitationDto
     */
    status: ReferralInvitationStatusEnum | null;
    /**
     * 
     * @type {number}
     * @memberof ReferralInvitationDto
     */
    amountCzk: number | null;
    /**
     * 
     * @type {Date}
     * @memberof ReferralInvitationDto
     */
    availableAt: Date | null;
}

export function ReferralInvitationDtoFromJSON(json: any): ReferralInvitationDto {
    return ReferralInvitationDtoFromJSONTyped(json, false);
}

export function ReferralInvitationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralInvitationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'registeredAt': (new Date(json['registeredAt'])),
        'status': ReferralInvitationStatusEnumFromJSON(json['status']),
        'amountCzk': json['amountCzk'],
        'availableAt': (json['availableAt'] === null ? null : new Date(json['availableAt'])),
    };
}

export function ReferralInvitationDtoToJSON(value?: ReferralInvitationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'registeredAt': (value.registeredAt.toISOString()),
        'status': ReferralInvitationStatusEnumToJSON(value.status),
        'amountCzk': value.amountCzk,
        'availableAt': (value.availableAt === null ? null : value.availableAt.toISOString()),
    };
}

